import { render, staticRenderFns } from "./CustomerDepHeadForm.vue?vue&type=template&id=71c8c61c&scoped=true&"
import script from "./CustomerDepHeadForm.vue?vue&type=script&lang=js&"
export * from "./CustomerDepHeadForm.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=71c8c61c&prod&lang=scss&scoped=true&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c8c61c",
  null
  
)

export default component.exports